<template>
    <transition name="fade">
        <div
            v-if="processes.length"
            class="downloader position-fixed left-3s bottom-3s"
        >
            <b-button
                variant="cinnabar"
                class="w-50-px h-50-px rounded-circle text-white"
                @click="toggle"
            >
                <i class="far fa-download"></i>
            </b-button>
            <div :class="{ show }" class="downloader-panel position-fixed">
                <b-card
                    header-class="px-3s py-2s"
                    body-class="p-3s"
                    class="border-1 border-white-smoke-5"
                >
                    <template #header>
                        <div
                            class="
                                d-flex
                                align-items-center
                                justify-content-between
                            "
                        >
                            <div>
                                <div
                                    class="
                                        d-inline-flex
                                        align-items-center
                                        justify-content-center
                                        border-2 border-navy-blue
                                        rounded-circle
                                        w-30-px
                                        h-30-px
                                    "
                                >
                                    <i class="fas fa-arrow-down"></i>
                                </div>
                                <span class="font-weight-semi-bold ml-2s">
                                    {{ processes.length }} left
                                </span>
                            </div>
                            <i
                                class="far fa-times cursor-pointer"
                                @click="hide"
                            ></i>
                        </div>
                    </template>
                    <div class="downloader-panel__wrapper max-h-300-px">
                        <DownloaderItem
                            v-for="(item, index) in processes"
                            :key="item.name + index"
                            :item="item"
                        ></DownloaderItem>
                    </div>
                </b-card>
            </div>
        </div>
    </transition>
</template>

<script>
import DownloaderItem from '@/components/downloader/DownloaderItem/DownloaderItem';
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'Downloader',
    components: { DownloaderItem },
    data() {
        return {
            show: true,
        };
    },
    computed: {
        ...mapState('downloader', ['processes']),
        ...mapGetters('auth', ['loggedIn']),
    },
    watch: {
        processes(value) {
            if (value && !this.show) {
                this.show = true;
            }
            this.alertLeaveListener(value);
        },
    },
    methods: {
        toggle() {
            this.show = !this.show;
        },
        hide() {
            this.show = false;
        },
        alertLeaveListener(processes) {
            if (processes && processes.length > 0) {
                this.addAlertLeave();
            } else {
                this.removeAlertLeave();
            }
        },
        addAlertLeave() {
            addEventListener('beforeunload', this.alertLeave);
        },
        removeAlertLeave() {
            removeEventListener('beforeunload', this.alertLeave);
        },
        alertLeave(event) {
            // TODO: Fix me on iOS later
            event.preventDefault();
            if (this.processes.length && this.loggedIn) {
                return (event.returnValue = '');
            } else {
                return true;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'Downloader';
</style>
